import { present } from 'shared/presenters/presenter'
import { Invited_Enthusiasts } from 'shared/presenters/graphqlTypes'

export class InvitedEnthusiastPresenter extends present<Invited_Enthusiasts>() {}
